<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="me-2 mb-2" v-if="!isEmployee">
            <div
              class="d-flex align-items-center border bg-white rounded p-1 me-2"
            >
              <router-link
                to="/attendance/attendance-admin"
                class="btn btn-icon btn-sm active bg-primary text-white me-1"
              >
                <i class="ti ti-brand-days-counter"></i>
              </router-link>
              <router-link
                to="/attendance/attendance-admin"
                class="btn btn-icon btn-sm"
              >
                <i class="ti ti-calendar-event"></i>
              </router-link>
            </div>
          </div>
          <!-- <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">
                    <i class="ti ti-file-type-xls me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div>
          </div> -->
          <div class="mb-2">
            <a
              href="javascript:void(0);"
              class="btn btn-primary d-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#attendance_report"
            >
              <i class="ti ti-file-analytics me-2"></i>Report
            </a>
          </div>
          <div class="ms-2 head-icons">
            <a
              href="javascript:void(0);"
              class=""
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <div
        v-if="store.state.hasStaleOpenPunch"
        class="alert alert-warning border-0 shadow-sm d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3"
        role="alert"
      >
        <div class="d-flex align-items-start gap-2">
          <i class="ti ti-alert-triangle fs-20 mt-1 text-warning"></i>
          <div>
            <div class="fw-semibold">Open punch from a previous day</div>
            <p class="mb-0 small text-muted">
              You forgot to punch out on
              <strong>{{ staleOpenDateLabel }}</strong>. Tap
              <strong>Punch Out</strong> to close that day before starting
              today. Open shifts are normally auto-closed at the end of each
              workday.
            </p>
          </div>
        </div>
        <button
          type="button"
          class="btn btn-dark btn-sm"
          @click="openPunchOut"
        >
          Punch Out now
        </button>
      </div>

      <div class="row">
        <!-- Left: Hero & Punch -->
        <div class="col-xl-3 col-lg-4 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <div class="mb-3 text-center">
                <h6 class="fw-medium text-gray-5 mb-2">
                  {{ greeting }}, {{ displayName }}
                </h6>
                <h4>{{ nowLabel }}</h4>
              </div>

              <!-- Avatar circle -->
              <div
                class="attendance-circle-progress mx-auto mb-3"
                data-value="65"
              >
                <span class="progress-left">
                  <span class="progress-bar border-success"></span>
                </span>
                <span class="progress-right">
                  <span class="progress-bar border-success"></span>
                </span>
                <div class="avatar avatar-xxl avatar-rounded">
                  <img :src="avataUrl" alt="Img" />
                </div>
              </div>

              <div class="text-center">
                <!-- Today's shift chip (hide when shift is past) -->
                <div
                  v-if="showTodayShiftChip"
                  class="badge badge-md badge-primary mb-2"
                >
                  Today's Shift:
                  <div>{{ shiftLabel }}</div>
                </div>

                <!-- Next shift chip -->
                <div v-if="showNextShift" class="mb-2">
                  <span class="badge badge-outline-secondary">
                    Next: {{ nextShiftChip }}
                  </span>
                </div>

                <!-- Production -->
                <div
                  v-if="showProduction"
                  class="badge badge-md badge-primary mb-3"
                >
                  Production : {{ todayHoursLabel }}
                </div>
                <div
                  v-else-if="store.state.hasStaleOpenPunch"
                  class="text-muted small mb-3"
                >
                  Close the previous day's punch to start today's attendance
                </div>
                <div v-else class="text-muted small mb-3">
                  Production hours starts after you clock in
                </div>

                <!-- Check-in info -->
                <h6
                  class="fw-medium d-flex align-items-center justify-content-center mb-3"
                >
                  <i class="ti ti-fingerprint text-primary me-1"></i>
                  {{ checkLine }}
                </h6>

                <div
                  v-if="!store.state.isClockedIn && !canPunchIn && guardReason"
                  class="alert bg-secondary-transparent alert-dismissible fade show mb-3"
                >
                  {{ guardReason }}
                  <button
                    type="button"
                    class="btn-close fs-14"
                    @click="store.clearBanner()"
                  >
                    <i class="ti ti-x"></i>
                  </button>
                </div>

                <!-- Action button -->
                <a
                  href="javascript:void(0);"
                  class="btn w-100"
                  :class="
                    store.state.isClockedIn
                      ? 'btn-dark'
                      : canPunchIn
                      ? 'btn-success'
                      : 'btn-secondary'
                  "
                  :disabled="!store.state.isClockedIn && !canPunchIn"
                  @click="
                    store.state.isClockedIn ? openPunchOut() : store.punchIn({})
                  "
                >
                  <template v-if="store.state.isClockedIn">
                    Punch Out
                  </template>
                  <template
                    v-else-if="
                      !canPunchIn && store.state.todayRecord?.check_out_at
                    "
                  >
                    Shift ended
                  </template>
                  <template v-else> Punch In </template>
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Right: KPI Cards -->
        <div class="col-xl-9 col-lg-8 d-flex">
          <div class="row flex-fill">
            <!-- Today -->
            <div class="col-xl-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="border-bottom mb-2 pb-2">
                    <span class="avatar avatar-sm bg-primary mb-2">
                      <i class="ti ti-clock-stop"></i>
                    </span>
                    <h2 class="mb-2">
                      {{ todayHoursLabel }} /
                      <span class="fs-20 text-gray-5">{{ todayTargetLabel }}</span>
                    </h2>
                    <p class="fw-medium text-truncate mb-0">Total Hours Today</p>
                    <p v-if="todayTargetHint" class="text-muted fs-11 mb-0 mt-1">
                      {{ todayTargetHint }}
                    </p>
                  </div>
                  <div>
                    <p class="d-flex align-items-center fs-13">
                      <span
                        class="avatar avatar-xs rounded-circle flex-shrink-0 me-2"
                        :class="todayTrend.cls"
                      >
                        <i :class="todayTrend.arrow + ' fs-12'"></i>
                      </span>
                      <span>{{ Math.abs(todayTrend.pct) }}% of Target</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Week -->
            <div class="col-xl-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="border-bottom mb-2 pb-2">
                    <span class="avatar avatar-sm bg-dark mb-2">
                      <i class="ti ti-clock-up"></i>
                    </span>
                    <h2 class="mb-2">
                      {{ weekHoursLabel }} /
                      <span class="fs-20 text-gray-5">{{ weekTargetLabel }}</span>
                    </h2>
                    <p class="fw-medium text-truncate mb-0">Total Hours Week</p>
                    <p v-if="weekTargetHint" class="text-muted fs-11 mb-0 mt-1">
                      {{ weekTargetHint }}
                    </p>
                  </div>
                  <div>
                    <p class="d-flex align-items-center fs-13">
                      <span
                        class="avatar avatar-xs rounded-circle flex-shrink-0 me-2"
                        :class="weekTrend.cls"
                      >
                        <i :class="weekTrend.arrow + ' fs-12'"></i>
                      </span>
                      <span>{{ Math.abs(weekTrend.pct) }}% of Target</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Month -->
            <div class="col-xl-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="border-bottom mb-2 pb-2">
                    <span class="avatar avatar-sm bg-info mb-2">
                      <i class="ti ti-calendar-up"></i>
                    </span>
                    <h2 class="mb-2">
                      {{ monthHoursLabel }} /
                      <span class="fs-20 text-gray-5">{{ monthTargetLabel }}</span>
                    </h2>
                    <p class="fw-medium text-truncate mb-0">Total Hours Month</p>
                    <p v-if="monthTargetHint" class="text-muted fs-11 mb-0 mt-1">
                      {{ monthTargetHint }}
                    </p>
                  </div>
                  <div>
                    <p class="d-flex align-items-center fs-13 text-truncate">
                      <span
                        class="avatar avatar-xs rounded-circle flex-shrink-0 me-2"
                        :class="monthTrend.cls"
                      >
                        <i :class="monthTrend.arrow + ' fs-12'"></i>
                      </span>
                      <span>{{ Math.abs(monthTrend.pct) }}% of Target</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Overtime -->
            <div class="col-xl-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="border-bottom mb-2 pb-2">
                    <span class="avatar avatar-sm bg-pink mb-2">
                      <i class="ti ti-calendar-star"></i>
                    </span>
                    <h2 class="mb-2">
                      {{ overtimeMonthLabel }} /
                      <span class="fs-20 text-gray-5">{{ overtimeBaselineLabel }}</span>
                    </h2>
                    <p class="fw-medium text-truncate">Overtime this Month</p>
                  </div>
                  <div>
                    <p class="d-flex align-items-center fs-13 text-truncate">
                      <span
                        class="avatar avatar-xs rounded-circle flex-shrink-0 me-2"
                        :class="otTrend.cls"
                      >
                        <i :class="otTrend.arrow + ' fs-12'"></i>
                      </span>
                      <span>{{ Math.abs(otTrend.pct) }}% vs Baseline</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Today timeline -->
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-xl-3">
                      <div class="mb-3">
                        <p class="d-flex align-items-center mb-1">
                          <i
                            class="ti ti-point-filled text-dark-transparent me-1"
                          ></i>
                          Total time at work
                        </p>
                        <h3>{{ sessionHoursLabel }}</h3>
                      </div>
                    </div>
                    <div class="col-xl-3">
                      <div class="mb-3">
                        <p class="d-flex align-items-center mb-1">
                          <i class="ti ti-point-filled text-success me-1"></i>
                          Productive Hours
                        </p>
                        <h3>{{ todayHoursLabel }}</h3>
                      </div>
                    </div>
                    <div class="col-xl-3">
                      <div class="mb-3">
                        <p class="d-flex align-items-center mb-1">
                          <i class="ti ti-point-filled text-warning me-1"></i>
                          Break hours
                        </p>
                        <h3>{{ breakHoursLabel }}</h3>
                      </div>
                    </div>
                    <div class="col-xl-3">
                      <div class="mb-3">
                        <p class="d-flex align-items-center mb-1">
                          <i class="ti ti-point-filled text-info me-1"></i>
                          Overtime
                        </p>
                        <h3>{{ overtimeHoursLabel }}</h3>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <p
                        v-if="dayTimeline.empty"
                        class="text-muted fs-12 mb-2"
                      >
                        {{ dayTimeline.message }}
                      </p>
                      <div
                        class="progress bg-transparent-dark mb-3"
                        style="height: 24px"
                      >
                        <div
                          v-for="(segment, idx) in dayTimeline.segments"
                          :key="idx"
                          class="progress-bar"
                          :class="segment.class"
                          role="progressbar"
                          :style="{ width: segment.widthPct + '%' }"
                        ></div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        class="d-flex align-items-center justify-content-between flex-wrap row-gap-2"
                      >
                        <span
                          v-for="(tick, idx) in dayTimeline.ticks"
                          :key="idx"
                          class="fs-10"
                        >
                          {{ tick }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /row flex-fill -->
        </div>
        <!-- /Right KPI -->
      </div>
      <!-- /row -->

      <!-- Table + Filters -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Employee Attendance</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
          >
            <div class="me-3">
              <div class="input-icon w-120 position-relative">
                <span class="input-icon-addon">
                  <i class="ti ti-calendar"></i>
                </span>
                <date-picker
                  v-model="startdate"
                  class="form-control datetimepicker"
                  placeholder="dd/mm/yyyy"
                  :editable="true"
                  :clearable="false"
                  :input-format="dateFormat"
                  @change="applyDateFilter(startdate)"
                />
              </div>
            </div>

            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {{ statusDropdownLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="
                      statusDropdownLabel = 'Present';
                      applyStatusFilter('Present');
                    "
                  >
                    Present
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="
                      statusDropdownLabel = 'Absent';
                      applyStatusFilter('Absent');
                    "
                  >
                    Absent
                  </a>
                </li>
                <li><hr class="dropdown-divider" /></li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="
                      statusDropdownLabel = 'Select Status';
                      applyStatusFilter('');
                    "
                  >
                    Clear
                  </a>
                </li>
              </ul>
            </div>

            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {{ sortDropdownLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="
                      sortDropdownLabel = 'Recently Added';
                      sortBy('Recently Added');
                    "
                  >
                    Recently Added
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="
                      sortDropdownLabel = 'Ascending';
                      sortBy('Ascending');
                    "
                  >
                    Ascending
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="
                      sortDropdownLabel = 'Descending';
                      sortBy('Descending');
                    "
                  >
                    Descending
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="
                      sortDropdownLabel = 'Last Month';
                      sortBy('Last Month');
                    "
                  >
                    Last Month
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="
                      sortDropdownLabel = 'Last 7 Days';
                      sortBy('Last 7 Days');
                    "
                  >
                    Last 7 Days
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="
                      sortDropdownLabel = 'Last 30 Days';
                      sortBy('Last 30 Days');
                    "
                  >
                    Last 30 Days
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="
                      sortDropdownLabel = 'This Month';
                      sortBy('This Month');
                    "
                  >
                    This Month
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- <div>{{ user }}</div> -->

        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <attendance-employee-table
              :rows="store.records"
              :loading="store.loading"
            />
          </div>
        </div>
      </div>
      <!-- /Table + Filters -->
    </div>

    <!-- Punch Out Modal -->
    <div
      class="modal fade show"
      tabindex="-1"
      style="display: block"
      v-if="punchOutOpen"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Punch Out</h4>
            <button
              type="button"
              class="btn-close custom-btn-close"
              @click="punchOutOpen = false"
            >
              <i class="ti ti-x"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Break minutes</label>
              <input
                type="number"
                min="0"
                class="form-control"
                v-model.number="breakMinutes"
                placeholder="0"
              />
              <small class="text-muted">
                Optional: total break taken during this shift.
              </small>
            </div>
            <div class="mb-0">
              <label class="form-label">Notes (optional)</label>
              <textarea
                class="form-control"
                rows="3"
                v-model="punchNotes"
                placeholder="Any notes..."
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-white" @click="punchOutOpen = false">
              Cancel
            </button>
            <button class="btn btn-dark" @click="confirmPunchOut">
              Confirm &amp; Punch Out
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" v-if="punchOutOpen"></div>
    <!-- /Punch Out Modal -->

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary">
          DoneQuik Technological World
        </a>
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->

  <attendance-employee-modal></attendance-employee-modal>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import AttendanceEmployeeTable from "./attendance-employee-table.vue";
import AttendanceEmployeeModal from "@/components/modal/attendance-employee-modal.vue";
import { useAttendanceEmployeeStore } from "@/stores/attendanceEmployeeStore";
import { useAuthStore } from "@/stores/authStore";
import { resolveAvatarUrl } from "@/utils/imageHelpers";
import {
  buildAttendanceDayTimeline,
  breakMinutesLabel,
  minutesToShortLabel,
} from "@/utils/attendanceDayTimeline";
import {
  formatAttendanceTime,
  formatAttendanceDate,
  parseAttendanceDateTime,
} from "@/utils/attendanceDateTime";


// ========== REACTIVE STATE ==========
const title = ref("Employee Attendance");
const text = ref("Employee");
const text1 = ref("Employee Attendance");

// date-picker bindings
const startdate = ref(new Date());
const dateFormat = ref("dd-MM-yyyy");

// live clock tick
const nowTick = ref(Date.now());
let nowTimer = null;

// dropdown labels
const statusDropdownLabel = ref("Select Status");
const sortDropdownLabel = ref("Sort By : Last 7 Days");

// punch-out modal state
const punchOutOpen = ref(false);
const breakMinutes = ref(0);
const punchNotes = ref("");

// ========== STORES ==========
const auth = useAuthStore();
const store = useAttendanceEmployeeStore();

// ========== COMPUTED PROPERTIES ==========
const currentEmployeeId = computed(() => auth.user?.employee?.id || null);

// User Info
const displayName = computed(() => auth.user?.first_name || "Employee");
const isEmployee = computed(() => auth.user.roles.includes("Employee"));
const avataUrl = computed(
  () => auth.user ?  resolveAvatarUrl(auth.user?.employee?.avatar_url) : ''
);

const hasTodaySchedule = computed(() => {
  const s = store.mySchedule;
  return !!(s && s.start_time && s.end_time);
});

const hasAnyUpcoming = computed(() => (store.upcoming?.length || 0) > 0);
const currentDateStr = ref(new Date().toISOString().slice(0, 10)); // YYYY-MM-DD

// Greetings & Time
const greeting = computed(() => {
  void nowTick.value;
  const tz = store.settings.timezone;
  const hour = tz
    ? Number(
        new Intl.DateTimeFormat("en-US", {
          hour: "numeric",
          hour12: false,
          timeZone: tz,
        }).format(new Date())
      )
    : new Date().getHours();
  if (hour < 12) return "Good Morning";
  if (hour < 17) return "Good Afternoon";
  return "Good Evening";
});

const nowLabel = computed(() => {
  void nowTick.value;
  const tz = store.settings.timezone;
  const d = new Date();
  const opts = tz ? { timeZone: tz } : {};
  const time = d.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    ...opts,
  });
  const date = d.toLocaleDateString([], opts);
  return `${time}, ${date}`;
});

// Attendance Status
const staleOpenDateLabel = computed(() =>
  formatAttendanceDate(store.state.staleOpenWorkDate)
);

const checkLine = computed(() => {
  const r = store.state.todayRecord;
  if (!r) return "Not yet punched in";
  if (store.state.hasStaleOpenPunch && r.check_in_at) {
    return `Still open since ${timeHHMM(r.check_in_at)} on ${staleOpenDateLabel.value}`;
  }
  if (r.check_out_at) return `Clocked out at ${timeHHMM(r.check_out_at)}`;
  if (r.check_in_at) return `Clocked in at ${timeHHMM(r.check_in_at)}`;
  if (String(r.status || "").toLowerCase() === "absent") {
    return "Marked absent — punch in to record attendance";
  }
  return "Not yet punched in";
});

// KPI Labels
const todayHoursLabel = computed(() =>
  minutesToLabel(store.state.todayMinutes)
);
const weekHoursLabel = computed(() => minutesToLabel(store.state.weekMinutes));
const monthHoursLabel = computed(() =>
  minutesToLabel(store.state.monthMinutes)
);

const dailyTargetMinutes = computed(() =>
  store.state.todayTargetMinutes > 0
    ? store.state.todayTargetMinutes
    : store.scheduledBaselineMinutes()
);
const shiftWindow = computed(() => {
  const s = store.mySchedule;
  if (s?.date && s?.start_time && s?.end_time) {
    const start = dtAtLocal(s.date, s.start_time);
    let end = dtAtLocal(s.date, s.end_time);
    if (end <= start) end = new Date(end.getTime() + 24 * 60 * 60 * 1000);
    return {
      start,
      end,
      breakMinutes: s.break_minutes || store.settings.defaultShiftBreakMinutes || 60,
    };
  }

  const d = new Date();
  const date = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  const start = dtAtLocal(date, store.settings.defaultShiftStart || "09:00");
  let end = dtAtLocal(date, store.settings.defaultShiftEnd || "17:00");
  if (end <= start) end = new Date(end.getTime() + 24 * 60 * 60 * 1000);

  return {
    start,
    end,
    breakMinutes: store.settings.defaultShiftBreakMinutes || 60,
  };
});

const todayTargetHint = computed(() => {
  const br = shiftWindow.value.breakMinutes;
  if (!br) return "Target = scheduled shift length";
  return `Target excludes ${breakMinutesLabel(br)} break (9–5 = 8h on-site, 7h net)`;
});

const weekTargetHint = computed(() => {
  if (store.state.usesShiftRoster) {
    return "Target = sum of your published shifts this week (so far)";
  }
  const days = weekdaysElapsedThisWeek.value;
  const perDay = minutesToLabel(dailyTargetMinutes.value);
  return `Target = ${days} weekday${days === 1 ? "" : "s"} × ${perDay} net (this week so far)`;
});

const monthTargetHint = computed(() => {
  if (store.state.usesShiftRoster) {
    return "Target = sum of your published shifts this month (so far)";
  }
  const days = weekdaysElapsedThisMonth.value;
  const perDay = minutesToLabel(dailyTargetMinutes.value);
  return `Target = ${days} weekday${days === 1 ? "" : "s"} × ${perDay} net (this month so far)`;
});

const dayTimeline = computed(() => {
  void nowTick.value;
  return buildAttendanceDayTimeline({
    shiftStart: shiftWindow.value.start,
    shiftEnd: shiftWindow.value.end,
    breakMinutes: shiftWindow.value.breakMinutes,
    record: store.state.todayRecord,
    productiveMinutes: store.state.todayMinutes,
    now: new Date(),
  });
});

const sessionHoursLabel = computed(() =>
  minutesToShortLabel(dayTimeline.value.totalSessionMinutes),
);
const breakHoursLabel = computed(() =>
  breakMinutesLabel(dayTimeline.value.breakMinutes),
);
const overtimeHoursLabel = computed(() =>
  minutesToShortLabel(dayTimeline.value.overtimeMinutes),
);

const weekdaysElapsedThisWeek = computed(() =>
  countWorkdaysThisWeek(new Date())
);
const weekdaysElapsedThisMonth = computed(() =>
  countWorkdaysThisMonth(new Date())
);

const weekTargetMinutes = computed(() =>
  store.state.weekTargetMinutes > 0
    ? store.state.weekTargetMinutes
    : dailyTargetMinutes.value * weekdaysElapsedThisWeek.value
);
const monthTargetMinutes = computed(() =>
  store.state.monthTargetMinutes > 0
    ? store.state.monthTargetMinutes
    : dailyTargetMinutes.value * weekdaysElapsedThisMonth.value
);

const todayTargetLabel = computed(() => minutesToLabel(dailyTargetMinutes.value));
const weekTargetLabel = computed(() => minutesToLabel(weekTargetMinutes.value));
const monthTargetLabel = computed(() => minutesToLabel(monthTargetMinutes.value));
const overtimeBaselineLabel = computed(() => minutesToLabel(0));

// KPI Trends
const todayTrend = computed(() =>
  trendFromPct(pctOfTarget(store.state.todayMinutes, dailyTargetMinutes.value))
);
const weekTrend = computed(() =>
  trendFromPct(pctOfTarget(store.state.weekMinutes, weekTargetMinutes.value))
);
const monthTrend = computed(() =>
  trendFromPct(pctOfTarget(store.state.monthMinutes, monthTargetMinutes.value))
);

// Overtime
const overtimeMonthMinutes = computed(() => {
  const expected = monthTargetMinutes.value;
  return Math.max(0, (store.state.monthMinutes || 0) - expected);
});

const overtimeMonthLabel = computed(() => {
  const m = overtimeMonthMinutes.value;
  const h = Math.floor(m / 60),
    r = m % 60;
  return `${h}h ${String(r).padStart(2, "0")}m`;
});

const otTrend = computed(() => {
  const expected = monthTargetMinutes.value;
  const m = overtimeMonthMinutes.value;
  const pct = expected > 0 ? Math.round((m / expected) * 100) : 0;
  return {
    pct,
    up: m > 0,
    cls: m > 0 ? "bg-success" : "bg-secondary",
    arrow: m > 0 ? "ti ti-arrow-up" : "ti ti-minus",
  };
});

// Shift Management
// const isShiftPast = computed(() => {
//   void nowTick.value;
//   const s = store.mySchedule;
//   if (!s?.date || !s?.end_time) return false;

//   const start = s.start_time ? dtAtLocal(s.date, s.start_time) : null;
//   let end = dtAtLocal(s.date, s.end_time);

//   // Handle overnight shifts
//   if (start && end <= start) {
//     end.setDate(end.getDate() + 1);
//   }

//   return Date.now() > end.getTime();
// });

const isShiftPast = computed(() => {
  void nowTick.value; // force recompute every 30s
  const s = store.mySchedule;
  const nowMs = Date.now();

  // 1) If we have a real schedule row for today
  if (s?.date && s?.end_time) {
    const start = s.start_time ? dtAtLocal(s.date, s.start_time) : null;
    let end = dtAtLocal(s.date, s.end_time);

    // Handle overnight assigned shifts
    if (start && end <= start) {
      end.setDate(end.getDate() + 1);
    }

    return nowMs > end.getTime();
  }

  // 2) No schedule → use default shift window if enabled
  if (store.settings.unscheduledMode === "default_shift") {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const date = `${y}-${m}-${day}`;

    const start = dtAtLocal(date, store.settings.defaultShiftStart);
    let end = dtAtLocal(date, store.settings.defaultShiftEnd);

    // Handle potential overnight default shift
    if (end <= start) {
      end.setDate(end.getDate() + 1);
    }

    return nowMs > end.getTime();
  }

  // 3) free_clock or unknown → never "past" from chip POV
  return false;
});

// const shiftLabel = computed(() => {
//   const s = store.mySchedule;

//   // real assigned shift → always display
//   if (s?.start_time && s?.end_time) {
//     const br = s.break_minutes ? ` (${s.break_minutes}m break)` : "";
//     return `${fmtHHMM(s.start_time)}–${fmtHHMM(s.end_time)}${br}`;
//   }

//   // only show default shift if employee is *truly* unscheduled (no upcoming)
//   if (
//     !hasAnyUpcoming.value &&
//     store.settings.unscheduledMode === "default_shift"
//   ) {
//     return `${fmtHHMM(store.settings.defaultShiftStart)}–${fmtHHMM(
//       store.settings.defaultShiftEnd
//     )} (${store.settings.defaultShiftBreakMinutes}m break)`;
//   }

//   return "";
// });

const shiftLabel = computed(() => {
  const s = store.mySchedule;

  // 1) Real assigned shift → always display
  if (s?.start_time && s?.end_time) {
    const br = s.break_minutes ? ` (${s.break_minutes}m break)` : "";
    // return `${fmtHHMM(s.start_time)}–${fmtHHMM(s.end_time)}${br}`;
     return `${fmtHHMM(s.start_time)}–${fmtHHMM(s.end_time)}`;
  }

  // 2) No schedule → show general/default shift if enabled
  if (store.settings.unscheduledMode === "default_shift") {
    const br = store.settings.defaultShiftBreakMinutes
      ? ` (${store.settings.defaultShiftBreakMinutes}m break)`
      : "";

    //    return `${fmtHHMM(store.settings.defaultShiftStart)}–${fmtHHMM(
    //   store.settings.defaultShiftEnd
    // )}${br}`;
      
    return `${fmtHHMM(store.settings.defaultShiftStart)}–${fmtHHMM(
      store.settings.defaultShiftEnd
    )}`;
  }

  // 3) free_clock or nothing special
  return "";
});

// const showTodayShiftChip = computed(
//   () => !!shiftLabel.value && !isShiftPast.value
// );

const showTodayShiftChip = computed(
  () => !!shiftLabel.value && !isShiftPast.value
);

// const showTodayShiftChip = computed(() => {
//   if (!hasTodaySchedule.value) return false;
//   return !isShiftPast.value;
// });

const nextShiftChip = computed(() => {
  const n = store.upcoming?.[0];
  if (!n) return null;
  const datePart = new Date(n.date).toLocaleDateString([], {
    weekday: "short",
    day: "2-digit",
    month: "short",
  });
  const start = (n.start_time || "").slice(0, 5);
  const end = (n.end_time || "").slice(0, 5);
  return `${datePart} · ${start}-${end}`;
});

const showNextShift = computed(
  () => !showTodayShiftChip.value && !!nextShiftChip.value
);

// Production & Guards
const showProduction = computed(
  () =>
    !store.state.hasStaleOpenPunch &&
    (store.state.isClockedIn || (store.state.todayMinutes || 0) > 0)
);

const canPunchIn = computed(() => store.canPunchInNow(new Date()));
const guardReason = computed(() => store.banner);

// ========== HELPER FUNCTIONS ==========
function minutesToLabel(m) {
  const h = Math.floor((m || 0) / 60);
  const mm = (m || 0) % 60;
  return `${String(h).padStart(2, "0")}h ${String(mm).padStart(2, "0")}m`;
}

function countWorkdaysThisWeek(referenceDate = new Date()) {
  const current = new Date(referenceDate);
  const monday = new Date(current);
  const day = monday.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  monday.setDate(monday.getDate() + diff);
  monday.setHours(0, 0, 0, 0);

  let count = 0;
  for (let i = 0; i < 7; i += 1) {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    if (d > current) break;
    const weekDay = d.getDay();
    if (weekDay !== 0 && weekDay !== 6) count += 1;
  }

  return Math.max(count, 1);
}

function countWorkdaysThisMonth(referenceDate = new Date()) {
  const current = new Date(referenceDate);
  const start = new Date(current.getFullYear(), current.getMonth(), 1);
  let count = 0;

  for (let d = new Date(start); d <= current; d.setDate(d.getDate() + 1)) {
    const weekDay = d.getDay();
    if (weekDay !== 0 && weekDay !== 6) count += 1;
  }

  return Math.max(count, 1);
}

function pctOfTarget(current, target) {
  if (!target) return 0;
  return Math.round((current / target) * 100);
}

function trendFromPct(pct) {
  return {
    pct,
    up: pct >= 100,
    cls: pct >= 100 ? "bg-success" : "bg-warning",
    arrow: pct >= 100 ? "ti ti-arrow-up" : "ti ti-arrow-right",
  };
}

function timeHHMM(v) {
  return formatAttendanceTime(v);
}

function dtAtLocal(dateStr, hhmm) {
  const parts = (hhmm || "").split(":").map(Number);
  const [HH = 0, MM = 0, SS = 0] = parts;
  const [y, m, d] = dateStr.split("-").map(Number);
  return new Date(y, m - 1, d, HH, MM, SS || 0, 0);
}

function fmtHHMM(t) {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  const d = new Date();
  d.setHours(h, m || 0, 0, 0);
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

// ========== FILTER FUNCTIONS ==========
function applyDateFilter(d) {
  let ymd = "";
  try {
    const dt = d instanceof Date ? d : new Date(d);
    ymd = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(dt.getDate()).padStart(2, "0")}`;
  } catch {}
  store.filters.date = ymd;
  store.fetchRecords({ date: ymd, page: 1 });
}

function applyStatusFilter(status) {
  store.filters.status = status || "";
  store.fetchRecords({ status: store.filters.status, page: 1 });
}

function sortBy(range) {
  const now = new Date();
  const to = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(now.getDate()).padStart(2, "0")}`;
  let from = "";

  if (range === "Last 7 Days") {
    const d = new Date();
    d.setDate(d.getDate() - 6);
    from = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(d.getDate()).padStart(2, "0")}`;
  } else if (range === "Last 30 Days") {
    const d = new Date();
    d.setDate(d.getDate() - 29);
    from = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(d.getDate()).padStart(2, "0")}`;
  } else if (range === "This Month") {
    const d = new Date(now.getFullYear(), now.getMonth(), 1);
    from = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(d.getDate()).padStart(2, "0")}`;
  } else if (range === "Last Month") {
    const d1 = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const d2 = new Date(now.getFullYear(), now.getMonth(), 0);
    store.filters.date_from = `${d1.getFullYear()}-${String(
      d1.getMonth() + 1
    ).padStart(2, "0")}-${String(d1.getDate()).padStart(2, "0")}`;
    store.filters.date_to = `${d2.getFullYear()}-${String(
      d2.getMonth() + 1
    ).padStart(2, "0")}-${String(d2.getDate()).padStart(2, "0")}`;
    store.fetchRecords({
      date_from: store.filters.date_from,
      date_to: store.filters.date_to,
      page: 1,
    });
    return;
  } else if (
    range === "Ascending" ||
    range === "Descending" ||
    range === "Recently Added"
  ) {
    store.fetchRecords({ page: 1 });
    return;
  } else {
    store.fetchRecords({ page: 1 });
    return;
  }

  store.filters.date_from = from;
  store.filters.date_to = to;
  store.fetchRecords({ date_from: from, date_to: to, page: 1 });
}

// ========== UI FUNCTIONS ==========
function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function openPunchOut() {
  breakMinutes.value = store.state.todayRecord?.break_minutes || 0;
  punchNotes.value = "";
  punchOutOpen.value = true;
}

async function confirmPunchOut() {
  const bm = Math.max(0, parseInt(breakMinutes.value || 0, 10));
  await store.punchOut({ break_minutes: bm, notes: punchNotes.value });
  punchOutOpen.value = false;
}

// ========== LIFECYCLE ==========
onMounted(async () => {
  if (currentEmployeeId.value) {
    store.filters.employee_id = currentEmployeeId.value;
  }
  await Promise.all([
    store.fetchSettings(),
    store.fetchToday(
      currentEmployeeId.value ? { employee_id: currentEmployeeId.value } : {}
    ),
    store.fetchRecords({ page: 1 }),
    store.fetchMySchedule(),
    store.fetchMyUpcoming(),
  ]);

  nowTimer = setInterval(async () => {
    const now = new Date();
    nowTick.value = now.getTime();

    const dstr = now.toISOString().slice(0, 10);
    if (dstr !== currentDateStr.value) {
      currentDateStr.value = dstr;
      // Day changed → refresh "today" context
      await Promise.all([
        store.fetchToday(
          currentEmployeeId.value
            ? { employee_id: currentEmployeeId.value }
            : {}
        ),
        store.fetchMySchedule(),
        store.fetchMyUpcoming(),
        store.fetchRecords({ page: 1 }),
      ]);
    }
  }, 30000);
});

onBeforeUnmount(() => {
  if (nowTimer) clearInterval(nowTimer);
});
</script>


